import { UploadData, useUploadStore } from '../../../../store/uploadStore';
import React from 'react';
import { classes, stylesheet } from 'typestyle';
import { Blue10, Blue80, Green90, Red10, Red80 } from '@traceair/tds';
import { getGlobalProgress } from './getGlobalProgress';
import { UploadValidationStatus } from '../../../../consts/uploadValidationStatus';

const css = stylesheet({
  container: {
    position: 'relative',
    height: 8,
    borderRadius: 12,
    overflow: 'hidden',
  },
  indicator: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    background: Blue80,
  },
});

interface Props {
  currentUploads: UploadData[];
  globalValidationStatus: UploadValidationStatus | null;
  isCompleted: boolean;
}

export const GlobalUploadProgress = ({ currentUploads, globalValidationStatus, isCompleted }: Props) => {
  const { bytesPerSecond, fileRegistrationTimeMs } = useUploadStore();

  const progress = getGlobalProgress(currentUploads);
  const roundedProgress = Math.round(progress);

  const progressTitle = bytesPerSecond
    ? `${((bytesPerSecond * 8) / 1_000_000).toFixed(2)} Mbps; file registration: ${fileRegistrationTimeMs} ms`
    : undefined;

  const progressColor = globalValidationStatus === UploadValidationStatus.HasErrors ? Red10 : Blue10;
  const indicatorColor =
    globalValidationStatus === UploadValidationStatus.HasErrors ? Red80 : isCompleted ? Green90 : Blue80;

  return (
    <div className={css.container} title={progressTitle} style={{ background: progressColor }}>
      <div className={classes(css.indicator)} style={{ width: `${roundedProgress}%`, background: indicatorColor }} />
    </div>
  );
};
